/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";

const mutations = {
  [types.SET_RECIPES](state, recipes) {
    state.recipes = {
      ...recipes,
    }
  },

  [types.SET_ORIGINAL_RECIPE](state, originalRecipe) {
    // makes a deep copy of the original recipe
    state.originalRecipe = JSON.parse(JSON.stringify(originalRecipe));
  },

  [types.SET_IMAGE_URLS](state, imageUrls) {
    state.imageUrls = {
      ...imageUrls,
    }
  },

  [types.SET_PRICES](state, prices) {
    state.prices = {
      ...prices,
    }
  },

  [types.SET_DESIGN_DATA](state, { modelName, designData }) {
    state.modelName = modelName;
    state.designData = designData;
  },

  [types.SET_IS_PERSONALIZATION_INVALID](state, value) {
    state.isPersonalizationInvalid = value;
  },

  [types.CLEAN_DESIGN_DATA](state) {
    state.modelName = null;
    state.designData = null;
  },

  [types.IS_CUSTOMIZER_TRANSFERRED_MODEL](state, value) {
    state.isCustomizerTransferredModel = value;
  }
};

export default mutations;
